/*
 * Project: LegalPlace assistant
 * File: src\redux\reducers\output.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */


// TODO: use the reduce+filter 


import {
    EDIT_OPTION_VALUE,
    EDIT_VARIABLE_VALUE,
    INIT_OUTPUT_OPTION,
    INIT_OUTPUT_VARIABLE,
    EDIT_OPTION_RADIO,
    REM_OPTION_DUP,
    REM_VARIABLE_DUP,
    REMOVE_FIRST_OPTION,
    REMOVE_FIRST_VARIABLE,
    editOption,
    editVariable,
    initOutputOption,
    initOutputVariable,
    checkRadio

} from '../actions/output';
import {lpGetOptionById, lpGetVariableById, lpSetVariableById, reorderOption, initializeOptions, initializeVariables, reorderVariable, delReindexVariable, delReindexOption} from '../../logic/re_index';
import { getOptionPass, getVariablePass, lpIdGetCopy } from '../../logic/global_getter';
import { store } from '../../globals'
import { lpIdGetPure } from '../../logic/global_getter';
import lpApp from '../../app/lp_app';
import { Children } from 'react';

function variableReducer(state = {}, action) {
    switch (action.type) {
        case INIT_OUTPUT_VARIABLE:
            // TODO: [OPT]
            // console.log(action.id)
            let value = ""
            // console.log(store.getState().document_state.state)
            if(store.getState().document_state.state == 'continue')
                value = getVariablePass(action.id);
            else
                value = action.value
            value = action.value;
            // console.log(value)
            let result_ = { id: action.id, value: action.value }
            return result_;
        case EDIT_VARIABLE_VALUE:
            var result_ = {}
            //debugger;
            if (action.id === state.id) {
                result_ = {...state, value: action.value }
                return result_
            } else return state;
            return state;
        default:
            return state;
    }
    return state;
}

function optionReducer(state = {}, action) {
    switch (action.type) {
        case INIT_OUTPUT_OPTION:
            let value = ""
            if(store.getState().document_state.state == 'continue')
                value = lpApp.indexes.options.getOption(action.id).value;
            else
                value = false;
            value = action.value;
            let result_ = { id: action.id, value:  value}
            //-----------------------------------------------------
            lpApp.indexes.sections_cache.registerOption(action.id);
            //-----------------------------------------------------
            return result_;
        case EDIT_OPTION_VALUE:
            if (action.id == state.id){
                // debugger;
                // console.log("jhh")
                let c_id = lpIdGetPure(action.id);
                return {...state, value: action.value }
            }
            return state;
        default:
            return state;
    }
}

function optionSReducer(state = [], action) {
    initializeOptions();
    switch (action.type) {
        case INIT_OUTPUT_OPTION:
            var changed = false;
            state.map((idx, i) => {
                if (idx.id == action.id)
                    changed = true;
                reorderOption(idx, i);
            });
            if (!changed){
                let result = state.map(idx => idx);
                let new_guy = optionReducer({}, action)
                let length = result.length;
                result.push(new_guy);
                
                
                reorderOption(new_guy, length);
                return result
            }
            return state
        case EDIT_OPTION_VALUE:
            return state.map((idx, i) => {
                let opt_c = optionReducer(idx, action);
                
                
                reorderOption(opt_c, i);
                return opt_c;
            });
        case 'FLUSH_AND_LOAD':
                let opts = lpApp.indexes.sections_cache.loadSectionOptions(action.id);
                let result = [];
                result = opts.map(idx => {
                    return {id: idx, value : lpApp.indexes.options.getOption(idx).value}
                });
                
                return result;
        break
            
        default:
            return state;
    }
}


function variableSReducer(state = [], action) {
    initializeVariables()
    switch (action.type) {
        case INIT_OUTPUT_VARIABLE:
            // TODO: [OPT]
            // var result_ = state.map(idx => idx)
            var changed_ = false;
            var result_ = state.map((idx, i) => {
                if (idx.id == action.id)
                    changed_ = true;
                reorderVariable(idx, i);
                return idx
            });
            if (!changed_){
                let var_c = variableReducer({}, action)

                // Getting Value from index
                // TODO SUPER DIRTY HACK MUST FIX
                // INITIALIZATION MUST TAKE INTO CONSIDERATION
                // CONTINUE CASES
                var_c.value = lpApp.indexes.variables.getVariable(var_c.id).value;

                reorderVariable(var_c, result_.length);
                result_.push(var_c)
            }
            return result_;
        case EDIT_VARIABLE_VALUE:
        // if(lpIdGetPure(action.id) == 7)debugger;
            // var n_action = {...action };
            // if (typeof action.value == 'undefined')
            //     n_action = {...n_action, value: "" }
            // // update the state
            // let state_ = [].concat(state);
            let result = state.map((idx, i) => {
                reorderVariable(idx, i)
                return idx
            });
            let var_ = lpGetVariableById(action.id);
            if(typeof var_ == 'undefined')return result;
                
            result[var_.index].value = action.value;
            result[var_.index].key = action.key;
            lpApp.indexes.variables.updateVariable({id: action.id, value: action.value});
            // update the variable states
            lpSetVariableById(action.id, action.value);
            return result;
        default:
           return state;
    }
    return state;
}



function radiosReducer(state = [], action) {
    // uncheck all the radios
    return state.map((idx) => {
        if(idx.key == action.key){
            return {...idx, value: action.value}
        }
        else
            return idx
    })
}
function delOutputRed(state = [],index,is_var = false){
    let result = []
    state.map((idx, i) => {
        if(typeof idx.id == 'string'){
            let r = idx.id.split('_');
            if(r[1] != undefined && r[1] != index){
                result.push(idx);
                if(!is_var)
                    reorderOption(idx, i);
                else
                    reorderVariable(idx, i);
            } else {
                if(!is_var){
                    lpApp.indexes.options.delOption(idx.id);
                    delReindexOption(idx.id);
                }
                else{
                    lpApp.indexes.variables.delVariable(idx.id);
                    delReindexVariable(idx.id);
                }
            }
        } else {
            result.push(idx)
            if(!is_var)
                reorderOption(idx, i);
            else
                reorderVariable(idx, i);
        }
    });
    return result;

}


function removeFirst(state=[], id){
    
    let copy_code = id;
    let opts_to_move = []
    state.map(idx => {
        if(lpIdGetCopy(idx.id) == copy_code){
            opts_to_move.push(idx);
            state[lpApp.indexes.options.getOption(lpIdGetPure(idx.id)).index].value = idx.value
        }
    });
    let result = []
    state.map(idx => {
        if(lpIdGetCopy(idx.id) != copy_code){
            return idx;
        }
    })

    return result;
}

function getAllChildren(id, r = []){
    let result = [];
    id = lpIdGetPure(id);
    let now = lpApp.references.options[id].children;
    now.map(idx => {
        r.push(idx)
        getAllChildren(idx, r);
    });
    return r;
}

function getAllVariableChildren(ids = []){
    let result = []
    ids.map(idx => {
        lpApp.references.options[idx].variables.map(jdx => result.push(jdx));
    });
    return result;
}

window.check_ = getAllChildren
function delFirst(state = [], f_c, id){
    let result = []
    let all_firsts = getAllChildren(id);
    state.map((idx,i) => {
        let c_id = idx.id;
        if(lpIdGetCopy(c_id) == f_c){
            result.push({
                id: parseInt(lpIdGetPure(c_id)),
                key: idx.key,
                value: idx.value
            });
            reorderOption({
                id: parseInt(lpIdGetPure(c_id)),
                key: idx.key,
                value: idx.value
            }, i)

            // Cleaning index
            lpApp.indexes.options.delOption(c_id);
            delReindexOption(c_id);
        }else
            if(!all_firsts.includes(idx.id)){
                result.push(idx);
                reorderOption(idx, i)
            }
    });
    return result;
}
function delFirstV(state = [], f_c, id){
    let result = []
    let variables = getAllVariableChildren(getAllChildren(id, []));
    state.map((idx, i) => {
        let c_id = idx.id;
        if(lpIdGetCopy(c_id) == f_c){
            result.push({
                id: parseInt(lpIdGetPure(c_id)),
                value: idx.value
            });
            reorderVariable({
                id: parseInt(lpIdGetPure(c_id)),
                value: idx.value
            }, i)
            // Cleaning index
            lpApp.indexes.variables.delVariable(c_id);
            delReindexVariable(idx.id);
        } else {
            if(!variables.includes(idx.id)){
                result.push(idx);
                reorderVariable(idx, i)
            } else {
                // Cleaning index
                lpApp.indexes.variables.delVariable(c_id);
                delReindexVariable(idx.id);
            }
        }
    })
    // debugger;
    return result;
}

export function outputReducer(state = {
    o: [],
    v: [],
    c: []
}, action) {
    // console.time('out_red');
    let result;
    switch (action.type) {
        case INIT_OUTPUT_OPTION:
            result =  {...state, o: optionSReducer(state.o, action) };
            break
        case INIT_OUTPUT_VARIABLE:
            result = {...state, v: variableSReducer(state.v, action) };
            break
        case EDIT_OPTION_VALUE:
            result = {...state, o: optionSReducer(state.o, action) };
            break;
        case EDIT_VARIABLE_VALUE:
            result = {...state, v: variableSReducer(state.v, action) };
            break;
        case EDIT_OPTION_RADIO:
            result = {...state, o: radiosReducer(state.o, action) };
            break;
        case REM_OPTION_DUP:
            result = {...state, o: delOutputRed(state.o, action.id)}
            break;
        case REM_VARIABLE_DUP:
            result = {...state, v: delOutputRed(state.v, action.id, true)}
            break;
        case REMOVE_FIRST_OPTION:
            result = {...state, o: delFirst(state.o, action.first_copy, action.id)}
            break;
        case REMOVE_FIRST_VARIABLE:
            result = {...state, v: delFirstV(state.v, action.first_copy, action.id)}
            break;
        case 'FLUSH_AND_LOAD':
            result = optionSReducer(state.o, action);
            break;
        default:
            result = Object.assign({}, state);
            break;
    }
    // console.timeEnd('out_red')
    return result;
}





// WEBPACK FOOTER //
// ./src/redux/reducers/output.js